import type { NavigationTypeType } from "@quickpoint.me/shared";
import { type ReactElement, useEffect } from "react";
import { useRecoilCallback, useRecoilValue } from "recoil";
import type { ElementProps } from "../../functionalComponents/RenderPage";
import { NavigationType } from "../../state/navigation";
import { PageElementsFamily, createLocation } from "../../state/page";

const MoveBy = ({
	pageIndex,
	atomId,
}: ElementProps): ReactElement<ElementProps> => {
	const key = createLocation(pageIndex, atomId);
	const elementData = useRecoilValue(PageElementsFamily(key)).data;
	const setNavigationType = useRecoilCallback(
		({ set }) =>
			(val: NavigationTypeType) => {
				set(NavigationType, val);
			},
	);

	useEffect(() => {
		if (typeof elementData.content !== "string") return;
		const nav = elementData.content.trim();
		if (
			nav === "scroll" ||
			nav === "tap" ||
			nav === "scrollCards" ||
			nav === "scrollContinuous"
		) {
			setNavigationType(nav);
		}
	});
	return <></>;
};

export default MoveBy;
